module.exports = __webpack_public_path__ + "static/media/search.d62e8545.svg";